module.exports = __webpack_public_path__ + "static/media/KNY.44c20783.png";